document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('DdsFooterNewsletterForm');
  if (!form) return;

  var successContainer = document.getElementById('DdsFooterSuccess');
  var formFields = form.querySelector('.dds-footer__form');
  var spamNotice = form.querySelector('.dds-footer__spam');

  // Klaviyo config din data attributes
  var klaviyoCompany = form.getAttribute('data-klaviyo-company') || '';
  var klaviyoList = form.getAttribute('data-klaviyo-list') || '';

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var emailInput = document.getElementById('DdsFooterEmail');
    if (!emailInput || !emailInput.value) return;

    var emailVal = emailInput.value.trim();
    if (!emailVal) return;

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerText = 'Se trimite...';
    }

    // Tracking activitate on-site theMarketer (leagă sesiunea din browser de adresa de email)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: '__sm__set_email',
      email_address: emailVal
    });

    // Trimitem în paralel la theMarketer via Supabase Edge Function
    fetch('https://dvojdpygwauvhsyfgyfb.supabase.co/functions/v1/shopify-order-sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'themarketer_subscribe',
        email: emailVal,
        source: 'footer'
      })
    }).catch(function(err) {
      console.error('theMarketer footer subscription error:', err);
    });

    if (!klaviyoCompany || !klaviyoList) {
      console.warn('Klaviyo: company_id sau list_id lipsesc pe footer');
      showSuccess();
      return;
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Footer Newsletter DDS',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailVal
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: klaviyoList
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCompany, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function() {
      showSuccess();
    })
    .catch(function(err) {
      console.error('Klaviyo footer subscription error:', err);
      showSuccess();
    });
  });

  function showSuccess() {
    if (formFields) formFields.style.display = 'none';
    if (spamNotice) spamNotice.style.display = 'none';
    if (successContainer) successContainer.style.display = 'block';
  }
});
